export class ParseIntValueConverter {
  fromView(value) {
    if(!value){
      return;
    }
    return parseInt(value);
  }
}
